import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useTopicComments(data = {}) {
  const { enabled = false, classID, courseID, topicID, chapterID, configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getTopicComments() {
    return privateFetch
      .get(
        `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}/topic/${topicID}/comments`,
        configs
      )
      .then((res) => res.data);
  }

  return useQuery(['topic-section-comments', { data }], getTopicComments, {
    enabled,
    keepPreviousData: true,
  });
}

export default useTopicComments;
